// overwrites the browser behaviour to move to an anchor when specified in
// the url as a hash tag
// https://codepen.io/bstrilziw/pen/AIoqs
import $ from "cash-dom"
import signals from "signals"

// this prevents chrome to move the viewport automatically to the top when we
// actually want to manually move it somewhere else
if ("scrollRestoration" in window.history) {
  try {
    window.history.scrollRestoration = "manual"
  } catch {
    // ignore if it isn't setable
  }
}

const viewportHelper = {
  goTo: (selector, options = {}) => {
    const $target = $(selector)
    // usually the selector is a string when it came from our own code
    // so I would like to be notified about it
    if (!$target.length && typeof selector === "string") {
      throw Error(`Could not scroll to element: ${selector}`)
    }
    if (!$target.length) return

    scrollTo($target[0], options)
    // corrects the viewport in case the document has changed while scrolling
    setTimeout(() => scrollTo($target[0], options), 500)
    signals.emit("kenhub.viewport_changed")
  },

  // returns the percentage of the vertical visibility in the viewport
  verticalPercentageInViewport: (el) => {
    let visibleHeight
    if (el instanceof $) el = el[0]
    const rect = el.getBoundingClientRect()
    // return if element isn't in viewport at all
    if (rect.bottom <= middlebarHeight() || rect.top >= $(window).height()) {
      return 0
    }
    if (rect.bottom > $(window).height()) {
      visibleHeight = rect.height - (rect.bottom - $(window).height())
    } else if (rect.top < middlebarHeight()) {
      visibleHeight = rect.height + (rect.top - middlebarHeight())
    } else return 100

    return (visibleHeight / rect.height) * 100
  }
}

function scrollTo(target, options) {
  const offset =
    target.getBoundingClientRect().top +
      window.pageYOffset -
      middlebarHeight() -
      readyToLearnBannerHeight() -
      (options.margin || 0)
  window.scrollTo({...options, top: offset})
}

function middlebarHeight() {
  return document.querySelector(".middlebar")?.offsetHeight || 0
}

function readyToLearnBannerHeight() {
  return document.querySelector(".ready-to-learn-banner")?.offsetHeight || 0
}

export default viewportHelper
